import React, { Component } from 'react';
import {inject, observer} from "mobx-react";
import {withStyles, Container, Box, Grid, Tabs, Tab} from "@material-ui/core";

import {tabs} from "../../constants/settings";
import {styles} from "./styles";
import GeneralSettings from "./general";
import UsersManager from "./users";
import Brands from '../../components/Brand';
import SwitchClients from "./switchClient";

@inject('userStore')
@observer
class SettingsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: props.userStore?.isSuperClient ? "switch" : "general",
    }
  }

  checkTabAllow = (tab) => {
    const { user, clientSettings } = this.props.userStore;

    if (!user || !user.scopes) {
      return false;
    }

    if (tab.rolesDisallowed && (user && user.scopes.some(scope => tab.rolesDisallowed.includes(scope)))) {
      return false;
    }

    if (tab.label === 'Brands') {
      return clientSettings?.settings?.use_brand_feature === 'true';
    }

    return (!tab.rolesAllowed || (user && user.scopes.some(scope => tab.rolesAllowed.includes(scope))));
  }

  render() {
    const {tab} = this.state;
    const {classes, userStore} = this.props;
    const tabSettings = tabs.filter(t => t.value === tab).shift();
    const title = userStore.isSuperClient ? 'Admin Settings' : 'Account Settings';

    return (
      <Container className={classes.settings}>
        <Box align="left" component="h2" className={classes.headerTitle}>{title}</Box>
        <Grid container>
          <Grid item xs={12} sm={3} className={classes.wrapper}>
            <Box p={1} className={classes.leftPanel}>
              <Tabs
                orientation="vertical"
                variant="fullWidth"
                value={tab}
                onChange={(e, tab) => this.setState({tab})}
                className={classes.tabs}
              >
                {tabs.map(tab => {
                  if (this.checkTabAllow(tab)) {
                    return <Tab label={tab.label} value={tab.value} className={classes.tab} key={tab.value} />;
                  } else {
                    return null;
                  }
                })}
              </Tabs>
            </Box>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Container className={classes.container}>
              {tab === 'general' && this.checkTabAllow(tabSettings) && <GeneralSettings />}
              {tab === 'users' && this.checkTabAllow(tabSettings) && <UsersManager />}
              {tab === 'brands' && this.checkTabAllow(tabSettings) && <Brands />}
              {tab === 'switch' && this.checkTabAllow(tabSettings) && <SwitchClients />}
            </Container>
          </Grid>
        </Grid>
      </Container>
    )
  }
}

export default withStyles(styles)(SettingsContainer);
